export default __webpack_public_path__ + "static/media/synth3.2eee49bb.svg";